import React from 'react';
import Formsy from 'formsy-react';
import Modal from '../shared/Modal';
import DatePicker from '../form/DatePicker';
import withSplashMessage from '../splashMessage/withSplashMessage';
import { serviceAPI } from '../../InterfaceAPI/serviceAPI';
import { maskDateSQL } from '../../masks';
import { stringfyServerErrors } from '../../helpers/util';

class ServicesExportModal extends React.Component {
  state = {
    startDate: null,
    endDate: null
  };

  render() {
    return (
      <Modal isOpen={this.props.isOpen} onRequestClose={this.props.closeModal}>
        <Formsy className="form" onValidSubmit={this.handleSubmit}>
          <h2 className="h2 modal__heading">Export Services</h2>
          <div className="form__row">
            <p className="p">
              Select the date range for the services you would like to export.
            </p>
          </div>
          <div className="form__row form__row--spacer">
            <div className="form__row-item form__row-item--half">
              <p className="simple-input__label">Start Date</p>
              <DatePicker
                name="startDate"
                value={this.state.startDate}
                onChange={this.handleDateChange}
                required
              />
            </div>

            <div className="form__row-item form__row-item--half">
              <p className="simple-input__label">End Date</p>
              <DatePicker
                name="endDate"
                value={this.state.endDate}
                onChange={this.handleDateChange}
                required
              />
            </div>
          </div>
          <div className="form__row">
            <div className="form__row-item--half">
              <div
                className="btn btn--hollow-red btn--full-width"
                onClick={this.props.closeModal}
              >
                Cancel
              </div>
            </div>
            <div className="form__row-item--half">
              <input
                type="submit"
                className="btn btn--solid-blue btn--full-width"
                value="Export"
              />
            </div>
          </div>
        </Formsy>
      </Modal>
    );
  }

  handleDateChange = (date, name) => {
    this.setState({ [name]: date });
  };

  handleSubmit = () => {
    const { startDate, endDate } = this.state;
    const params = {
      start_date: maskDateSQL(startDate),
      end_date: maskDateSQL(endDate)
    };
    const filename = `services_${params.start_date}--${params.end_date}`;
    serviceAPI
      .exportServices(params, filename)
      .then(success => this.props.closeModal())
      .catch(error => {
        this.props.addMessage({
          className: 'error',
          message: stringfyServerErrors(error)
        });
        this.props.closeModal();
      });
  };
}
export default withSplashMessage(ServicesExportModal);



// WEBPACK FOOTER //
// ./src/components/services/ServicesExportModal.js